var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.fileName)?_c('div',[_c('i',[_vm._v(_vm._s(_vm.text)+" not available")])]):_c('div',[_c('strong',[_c('a',{staticClass:"el-button",attrs:{"href":_vm.url,"download":_vm.fileName}},[_c('i',{class:'el-icon-' + _vm.icon}),_vm._v(_vm._s(_vm.text)+" - "+_vm._s(_vm.fileName)+"\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }